export enum AccountRole {
    master,
    adminHotel,
    accountant,
    provider,
    secondaryAccountant,
    semiMaster,
}
